export var MessageStatus;
(function (MessageStatus) {
    MessageStatus["sending"] = "sending";
    MessageStatus["sent"] = "sent";
})(MessageStatus || (MessageStatus = {}));
export var ElementPosition;
(function (ElementPosition) {
    ElementPosition["TOP"] = "TOP";
    ElementPosition["BOTTOM"] = "BOTTOM";
})(ElementPosition || (ElementPosition = {}));
